import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  parse(value: any): Date | null {
    if ((typeof value === 'string') && (value.indexOf('.') > -1)) {
      const str = value.split('.');
      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);
      return new Date(year, month, date);
    }
    return super.parse(value); // Fallback for the native parser
  }

  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input' || typeof displayFormat === 'string') {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      return `${day < 10 ? '0' + day : day}.${month < 10 ? '0' + month : month}.${year}`;
    } else {
      return super.format(date, displayFormat);
    }
  }

  getFirstDayOfWeek(): number {
    return 1; // Monday
  }
}
